export default "__VITE_ASSET__D$88RY8N__"